/**
 * Handles the location detection and redirection to the appropriate market.
 *
 *
 * If the user is in Australia, it will redirect to the en-au URL.
 * If the user is in New Zealand, it will redirect to the en-nz URL.
 *
 * If the user has manually selected the market, then don't ask the market and
 * don't redirect to the appropriate market.
 */
export default function init() {
  const params = new URLSearchParams(window.location.search);
  let hasAskedMarket =
    params.has("has-asked-market") && params.get("has-asked-market") === "true";

  if (hasAskedMarket) {
    return;
  }

  //
  // if we have a manual selection of the market then don't ask the market
  hasAskedMarket = document.cookie.includes("has-asked-market");

  if (!hasAskedMarket) {
    // if its a bot then don't ask the market
    if (navigator.userAgent.includes("bot")) {
      return;
    }

    // if shopify design mode is active then don't ask the market
    if (document.body.classList.contains("shopify-design-mode")) {
      return;
    }

    // if URLSearchParams has a country parameter then don't ask the market
    if (new URLSearchParams(window.location.search).get("country")) {
      // set the has-asked-market cookie
      document.cookie =
        "has-asked-market=true; path=/; max-age=31536000; samesite=strict";
      return;
    }

    fetch("/browsing_context_suggestions.json")
      .then((res) => res.json())
      .then((data) => {
        const countryName = data.detected_values.country.name;

        // save the country to a cookie
        document.cookie = `market=${countryName}; path=/; max-age=31536000; samesite=strict`;

        // if country name is AU then make sure the url has en-au prefix
        if (countryName === "Australia") {
          if (window.location.pathname.includes("en-au")) {
            return;
          }

          // if the url has a ?country parameter then continue
          if (window.location.search.includes("country")) {
            return;
          }

          const params = new URLSearchParams(window.location.search);
          params.set("country", "au");
          params.set("market", "au");
          params.set("has-asked-market", "true");

          // trigger a click on the swap sites button
          // redirect to the en-au url with the new params
          window.location.href =
            "/en-au" + window.location.pathname + "?" + params.toString();
        }
      })
      .catch((error) => console.error("Error fetching country:", error));
  } else {
    // append the market cookie information to the #region-selector modal with a link to clear the cookie
    const regionSelector = document.querySelector("#region-selector");

    // get the `market` cookie
    const marketCookie = document.cookie
      .split("; ")
      .find((row) => row.startsWith("market="));
    const countryName = marketCookie?.split("=")[1];

    // clicking any a tag within the region-selector should set the has-asked-market cookie
    if (regionSelector) {
      const aTags = regionSelector.querySelectorAll("a.toggle-market");

      aTags.forEach((a) => {
        a.addEventListener("click", function (e) {
          e.preventDefault();

          // set the has-asked-market cookie
          document.cookie =
            "has-asked-market=true; path=/; max-age=31536000; samesite=strict";
        });
      });
    }

    if (regionSelector && countryName) {
      const termsP = document.createElement("p");
      termsP.classList.add("small-terms");
      termsP.innerHTML = `We've detected you are in ${countryName}. If this is incorrect, you can <a href="#" class="clear-market-cookie">clear the cookie</a> and try again.`;

      const modalContent = regionSelector.querySelector(".modal__content");

      if (modalContent) {
        modalContent.appendChild(termsP);
      }

      // add a click handler to the clear-market-cookie link
      const clearMarketCookie = document.querySelector(".clear-market-cookie");

      if (clearMarketCookie) {
        clearMarketCookie.addEventListener("click", function (e) {
          e.preventDefault();

          // remove the market cookie
          document.cookie = "market=; path=/; max-age=0; samesite=strict";

          // reload the page
          window.location.reload();
        });
      }
    }
  }
}
